exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar .ant-menu-item-active path {\n  fill: #6236FF;\n}\n.sidebar .ant-menu-item-selected path {\n  fill: #6236FF;\n}\n.sidebar .ant-menu-item-selected span {\n  color: #6236FF;\n}\n.sidebar-icon {\n  font-size: 20px !important;\n}\n.sidebar .submenu-icon {\n  line-height: 2.5;\n}\n.sidebar_scroll:first-child {\n  overflow-x: hidden;\n}\n.sidebar__lastMenu:last-child {\n  margin-bottom: 2rem;\n}\n.submenu-icon {\n  font-size: 20px !important;\n}\n", ""]);

// exports
